module.exports = new __parcel__URL__("yves-bismuth.0c5a4c42.jpeg").toString();